import PubSub from "underpub-js";

var CardTwo = function(options) {

	this.options = {
		$el: false,
		baseClass: 'el-CardTwo',
	};

	$.extend(true, this.options, options);

};

CardTwo.prototype.init = function() {

	var self = this;

};

export default CardTwo;
